// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__u8Bnb","logo":"sidebar_logo__dRcYi","nav":"sidebar_nav__GqQuV","side_bar_icon":"sidebar_side_bar_icon__6uS54","home_link":"sidebar_home_link__Y6o-n"};